import { render } from "./StudyAssistant.vue?vue&type=template&id=478d20a4"
import script from "./StudyAssistant.vue?vue&type=script&lang=js"
export * from "./StudyAssistant.vue?vue&type=script&lang=js"

import "./StudyAssistant.vue?vue&type=style&index=0&id=478d20a4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__